import React from 'react';
import { chip, muted, rowBorder, hm, dayLabel, groupByDay } from './styles';

// Shared components for the Time Tracking pages (helpers live in styles.js).

const STATUS = {
    DRAFT: { label: 'Not submitted', color: 'var(--text-muted)', bg: 'transparent' },
    SUBMITTED: { label: 'Awaiting approval', color: '#d97706', bg: 'rgba(217,119,6,0.12)' },
    APPROVED: { label: 'Approved', color: '#10b981', bg: 'rgba(16,185,129,0.12)' },
    REJECTED: { label: 'Returned for changes', color: '#ef4444', bg: 'rgba(239,68,68,0.12)' },
};

export const StatusBadge = ({ status }) => {
    const s = STATUS[status] || STATUS.DRAFT;
    return <span data-status={status} style={{ ...chip, color: s.color, background: s.bg, borderColor: s.color, fontSize: 12, fontWeight: 600 }}>{s.label}</span>;
};

export const Message = ({ message }) => message ? (
    <div role="status" style={{ padding: '10px 14px', borderRadius: 6, margin: '12px 0', background: message.ok ? 'rgba(16,185,129,0.12)' : 'rgba(239,68,68,0.12)', color: message.ok ? '#10b981' : '#ef4444', border: `1px solid ${message.ok ? 'rgba(16,185,129,0.3)' : 'rgba(239,68,68,0.3)'}` }}>
        {message.text}
    </div>
) : null;

const time = (iso) => new Date(iso).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

/** Read-only (or editable, with actions) list of entries grouped by day. */
export const EntryDays = ({ entries, actions }) => (
    <>
        {groupByDay(entries).map(d => (
            <section key={d.date} className="card" style={{ padding: 0, marginBottom: 12, overflow: 'hidden' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 14px', background: 'var(--accent-subtle)', fontWeight: 600 }}>
                    <span>{dayLabel(d.date)}</span><span>{hm(d.totalSec)}</span>
                </div>
                {d.entries.map(e => (
                    <div key={e.id} style={{ display: 'flex', gap: 12, alignItems: 'center', padding: '8px 14px', borderTop: rowBorder, flexWrap: 'wrap' }}>
                        <span style={{ width: 10, height: 10, borderRadius: '50%', background: e.project?.color, flexShrink: 0 }} />
                        <div style={{ flex: '1 1 200px' }}>
                            <div>{e.description || <em style={muted}>No description</em>}</div>
                            <div style={muted}>
                                {e.project?.client && `${e.project.client.name} · `}{e.project?.name}{e.task && ` · ${e.task.name}`}{!e.isBillable && ' · Non-billable'}
                                {e.needsReview && <span style={{ color: '#d97706', marginLeft: 8 }}>⚠ Timer was left running; please check the time</span>}
                            </div>
                        </div>
                        <span style={muted}>{time(e.startedAt)} – {time(e.endedAt)}</span>
                        <strong style={{ minWidth: 70, textAlign: 'right' }}>{hm(e.durationSec)}</strong>
                        {actions && actions(e)}
                    </div>
                ))}
            </section>
        ))}
    </>
);
